<template>
    <div class="progress-bar" :class="classes">
        <span class="meter" :style="meterStyle"></span>
    </div>
</template>

<script>
export default {
    props: {
        animated: { type: Boolean, default: true },
        type: { type: [String, Boolean], default: false },
        size: { type: [String, Boolean], default: false },
        value: { type: Number, default: 0 },
        max: { type: Number, default: 100 },
        isLoading: { type: Boolean, default: false },
    },

    data() {
        return {
            shownValue: 0,
        };
    },

    computed: {
        /**
         * Returns an Object representing the CSS styles that should be applied to the Meter..
         *
         * @returns {{width: string}}
         */
        meterStyle() {
            return {
                width: String(Math.floor((this.shownValue / this.max) * 100) + '%'),
            };
        },

        /**
         * Returns Array of classes for the parent element..
         *
         * @returns {Array}
         */
        classes() {
            let classes = [];

            if (this.animated) classes.push('animated');
            if (this.type) classes.push(this.type);
            if (this.size) classes.push(this.size);

            if (this.isLoading) classes.push('is-loading');

            return classes;
        },
    },

    watch: {
        value(value) {
            this.shownValue = value;
        },
    },

    mounted() {
        if (this.animated) {
            // This is so it animates from zero to initial state
            setTimeout(() => {
                this.shownValue = this.value;
            }, 300);
        } else {
            this.shownValue = this.value;
        }
    },
};
</script>
